import styled from "styled-components";

export const MySubTitle = styled.h2`
  color: #1d1d1b;
  text-transform: uppercase;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.25rem;
  margin-bottom: 1.94rem;
`;
